import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const NIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="NI" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#0080EC"
          fillRule="evenodd"
          d="M0 0v4h16V0H0ZM0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#D0AB00"
          d="M6.92 6.814c.226.3.57.502.966.535v.644a1.994 1.994 0 0 1-1.596-.96l.63-.219Zm2.836.142c-.317.58-.913.985-1.608 1.036v-.646c.37-.04.694-.23.914-.508l.694.118Zm-1.18-2.871A2 2 0 0 1 10 6c0 .033-.004.066-.006.099l-.642-.055L9.354 6c0-.608-.4-1.123-.952-1.294l.173-.621Zm-1.133.68c-.467.212-.794.68-.797 1.225l-.642.095C6.003 6.057 6 6.028 6 6a2 2 0 0 1 1.276-1.863l.167.629ZM8 4c.094 0 .186.009.276.021l-.098.637a1.365 1.365 0 0 0-.436.012l-.047-.645C7.795 4.01 7.896 4 8 4Z"
        />
        <Path
          fill="#7CDFFF"
          fillRule="evenodd"
          d="M7.987 4.475 6.62 6.84h2.758l-1.39-2.365Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={4}
          height={3}
          x={6}
          y={4}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M7.987 4.475 6.62 6.84h2.758l-1.39-2.365Z"
            clipRule="evenodd"
          />
        </Mask>
        <G mask="url(#c)">
          <Path
            stroke="#E31D1C"
            strokeWidth={0.5}
            d="M8 5.168a1.195 1.195 0 1 1 0 2.39 1.195 1.195 0 0 1 0-2.39Z"
          />
          <Path
            stroke="#FFD018"
            strokeWidth={0.5}
            d="M8 5.168a1.195 1.195 0 1 1 0 2.39 1.195 1.195 0 0 1 0-2.39Z"
          />
          <Path
            stroke="#4EDD00"
            strokeWidth={0.5}
            d="M8 5.168a1.195 1.195 0 1 1 0 2.39 1.195 1.195 0 0 1 0-2.39Z"
          />
          <Path
            stroke="#3D58DB"
            strokeWidth={0.5}
            d="M8 5.168a1.195 1.195 0 1 1 0 2.39 1.195 1.195 0 0 1 0-2.39Z"
          />
          <Path fill="#3D58DB" d="M6.509 6.109h3.127v.909H6.509z" />
          <Path
            fill="#97C923"
            fillRule="evenodd"
            d="m6.719 6.495.623-.62.191.31.134-.378.148.284.156-.216.202.216.185-.284.158.284.181-.216.424.45.076.17-2.478.126v-.126Z"
            clipRule="evenodd"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
